// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LTzHKUATVw3s3_n2vjCE{align-items:center;height:32px;padding:0 8px;font-size:13px;font-weight:400;display:flex}.LTzHKUATVw3s3_n2vjCE.rjoan1tLRyk73KR18ZdH{padding:0}.LTzHKUATVw3s3_n2vjCE .OZNKV3Cai6sj87ZbHm3t{color:var(--content-primary-tertiary);text-overflow:ellipsis;white-space:nowrap;width:110px;line-height:normal;overflow:hidden}.LTzHKUATVw3s3_n2vjCE .j1ZG6Jhi1EFyzk0qc8iS{white-space:nowrap;width:164px;color:var(--content-primary-primary);text-overflow:ellipsis;overflow:hidden}.LTzHKUATVw3s3_n2vjCE .j1ZG6Jhi1EFyzk0qc8iS .KsrlqkLldhMCfO6Cwi1m{border-radius:6px;padding:4px 8px!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemRow": `LTzHKUATVw3s3_n2vjCE`,
	"emptyPadding": `rjoan1tLRyk73KR18ZdH`,
	"label": `OZNKV3Cai6sj87ZbHm3t`,
	"value": `j1ZG6Jhi1EFyzk0qc8iS`,
	"textInput": `KsrlqkLldhMCfO6Cwi1m`
};
export default ___CSS_LOADER_EXPORT___;
